/* eslint-disable @typescript-eslint/no-use-before-define */
import { InsuredVehicle } from "@comparaonline/soap-schema";
import { getConfig } from "../../../../config/app";

const BFF_URL = getConfig("BFF.cl");

export const getFirstCarVehicleType = async (
  funnelId: string,
  insuredVehicles: InsuredVehicle[]
): Promise<InsuredVehicle> => {
  const plates = await getInsurablePlates(funnelId);
  return plates
    .map((plate: string) =>
      insuredVehicles.find(insuredVehicle => insuredVehicle.vehicle.plate == plate)
    )
    .filter(Boolean)[0] as InsuredVehicle;
};

async function getInsurablePlates(funnelId: string): Promise<string[]> {
  const response = await fetch(`${BFF_URL}/check-cross-selling/${funnelId}`, {
    headers: {
      Accept: "application/vnd.api+json"
    }
  }).then(response => response.json());
  return response.data ? deserialize(response.data) : [];
}

function deserialize(responseData: ResponseItem[]): string[] {
  return responseData.map((item: ResponseItem): string => item.attributes.plate);
}

interface ResponseItem {
  attributes: {
    plate: string;
  };
}
